module.exports = __webpack_public_path__ + "img/soundTutorial1.9dde1b89.png";